export default () => ({
  open: false,
  active: 0,
  paused: false,
  delay: 15000,

  init () {
    setTimeout(() => { this.open = true }, 250)
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
    this.items = this.$el.querySelectorAll('.story-items > *')
    this.thumb = this.$el.querySelector('.story-thumb')
    this.addThumbItems()
    this.activeSlide(0)
  },

  activeSlide (index) {
    this.active = index
    this.items.forEach((item) => item.classList.remove('active'))
    this.items[index].classList.add('active')
    this.thumbItems.forEach((item) => item.classList.remove('active'))
    this.thumbItems.forEach((item) => item.classList.remove('visualized'))
    this.thumbItems[index].classList.add('active')
    Array.from(Array(this.active).keys()).forEach((i) => this.thumbItems[i].classList.add('visualized'))
    this.autoSlide()
  },

  prev () {
    if (this.active > 0) {
      this.activeSlide(this.active - 1)
    } else {
      this.activeSlide(this.items.length - 1)
    }
  },

  next () {
    if (this.active < this.items.length - 1) {
      this.activeSlide(this.active + 1)
    } else {
      this.activeSlide(0)
    }
  },

  addThumbItems () {
    this.items.forEach(() => { this.thumb.innerHTML += '<span></span>' })
    this.thumbItems = Array.from(this.thumb.children)
  },

  pauseSlide () {
    if (this.paused) {
      this.paused = false
      clearTimeout(this.timeout)
      this.thumbItems[this.active].classList.remove('paused')
      this.timeout = setTimeout(this.next, this.remaining)
    } else {
      this.paused = true
      clearTimeout(this.timeout)
      this.thumbItems[this.active].classList.add('paused')
      this.remaining -= Date.now() - this.start
    }
  },

  autoSlide () {
    this.paused = false
    this.start = Date.now()
    this.remaining = this.delay
    clearTimeout(this.timeout)
    this.timeout = setTimeout(this.next, this.remaining)
  }
})
